// CLIENT PLUGIN
// src/blueprint/api/getPilotConsent.js

import apiFetch from '@wordpress/api-fetch';

export async function getPilotConsent() {
  return apiFetch({
    path: '/digivibe-savora/v1/savora/pilot/consent',
    method: 'GET',
  });
}
